import { createRef } from 'react';
import styled from 'styled-components';

import { IPlayer } from '../../shared/types/player.type';

import Board from './components/Board/Board';
import Dice from './components/Dice/Dice';
import PlayerSelector from './components/StatusPanel/PlayerSelector/PlayerSelector';
import PlayerSelectorWarning from './components/StatusPanel/PlayerSelector/PlayerSelectorWarning';
import PlayerNames from './components/StatusPanel/PlayerNames/PlayerNames';
import ChangesLog from './components/ChangesLog/ChangesLog';
import Row from './components/Helpers/Row';
import Xarrow from 'react-xarrows';
import ActicePlayerIndicator from './components/ActivePlayerIndicator/ActivePlayerIndicator';
import RestartButton from './components/RestartButton/RestartButton';

interface AppProps {
  tokenPositions: IPlayer[];
  diceNumber: number;
  move: string;
  changes: {
    text: string;
    from: [number, number] | [null, null];
    to: [number, number] | [null, null];
  }[];
  playerSelection: {
    isPlayerSelected: boolean[];
    selectedPlayer: number | null;
  };
  activePlayer: number | null;
  stateChangeId: number | null;
}

const StyledApp = styled.div`
  text-align: center;
  background-color: ${(p) => p.theme.background};
  min-height: 100vh;
`;

function App(props: AppProps) {
  const startRef = createRef();
  const endRef = createRef();

  const arrow =
    props.changes.length > 0 ? (
      <Xarrow
        start={startRef}
        end={endRef}
        headSize={4}
        color="magenta"
        strokeWidth={4}
      />
    ) : null;

  return (
    <div>
      <StyledApp>
        <Board
          tokenPositions={props.tokenPositions}
          changes={props.changes}
          startRef={startRef}
          endRef={endRef}
          selectedPlayer={props.playerSelection.selectedPlayer}
        />
        <Dice
          diceNumber={props.diceNumber}
          move={props.move}
          activePlayer={props.activePlayer}
          selectedPlayer={props.playerSelection.selectedPlayer}
          stateChangeId={props.stateChangeId}
        />
        <Row>
          <PlayerSelector playerSelection={props.playerSelection} />
          <PlayerNames />
          <ChangesLog changes={props.changes.map((change) => change.text)} />
        </Row>
        <PlayerSelectorWarning playerSelection={props.playerSelection} />
        <ActicePlayerIndicator
          activePlayer={props.activePlayer}
          selectedPlayer={props.playerSelection.selectedPlayer}
        />
        {arrow}
        <RestartButton selectedPlayer={props.playerSelection.selectedPlayer} />
      </StyledApp>
    </div>
  );
}

export default App;
